<template>
	<div class="p-0 h-100 d-flex flex-column" style="overflow: hidden;">
		<div class="bg-light-noise result-topbar" v-if="displayHeader">
			<nav v-if="loaded" class="navbar navbar-expand-lg navbar-light w-100 py-1 d-flex flex-row">
			  <div class="navbar-brand mr-0" v-if="manifest.label">{{ manifest.label }}</div>
			  <div v-if="starred" class="btn" @click="toggleUserManifest" data-toggle="tooltip" :title="__('translations.button.remove_from_my_documents')">
				<i class="fas fa-star text-info"></i>
		  	  </div>
		  	  <div v-else class="btn" @click="toggleUserManifest" data-toggle="tooltip" :title="__('translations.button.add_to_my_documents')">
				<i class="far fa-star text-info"></i>
		  	  </div>
		  	  <button style="display:none" class="btn btn-sm btn-outline-info ml-1" data-toggle="collapse" data-target="#collapseMetadata" aria-expanded="false" aria-controls="collapseMetadata">{{ __('translations.button.metadata') }}</button>
			  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
			    <span class="navbar-toggler-icon"></span>
			  </button>
			</nav>
		</div>
	    <div v-if="loaded" class="collapse" id="collapseMetadata">
			<div class="card card-body">
			  	<metadata :source="manifest" sourceType="manifest"></metadata>
			</div>
		</div>
        <div class="result-content p-3" style="flex: 1; overflow-y: auto;">
        	<div class="row">
	        	<section id="image-results" class="image-grid--compact cf">
					<canvas-result v-for="(canvas, index) in canvases.data" :key="index" class="animated fadeIn" :canvas="canvas"></canvas-result>
				</section>
			</div>
			<div v-if="canvases.total == 0">
		   		<div class="text-muted">{{ __('translations.message.no_canvases_found') }}</div>
		    </div>
		</div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import CanvasResult from './CanvasResult'
import Metadata from './Metadata'

export default {
	props: ['displayHeader'],
	components: {
		CanvasResult,
		Metadata
	},
	computed: {
		...mapGetters([
			'canvases', 'manifest'
		])
	},
	data() {
		return {
			loaded: false,
			starred: false,
			displayMetadata: false,
		}
	},
	created() {
		this.fetchCanvases();
		this.determineIfUserManifest();
	},
	watch: {
	    $route(to, from) {
	    	this.fetchCanvases();
	    	this.determineIfUserManifest();
	    }
	},
	methods: {
		fetchCanvases() {
			this.loaded = false;
			
			if(this.$route.name === 'canvases') {
				this.$store.dispatch('FETCH_CANVASES', {'cId': this.$route.params.cId, 'mId': this.$route.params.mId}).then(response => {
					this.loaded = true;
				});	
			}
		},
		determineIfUserManifest() {
			if(this.$route.name === 'canvases' && this.displayHeader) {
				axios.get('/determineIfUserManifest', {params: {'mId': this.$route.params.mId}}).then(response => {
					this.starred = response.data
				})
			}
		},
		toggleUserManifest() {
			if(this.starred) {
				axios.post('/removeUserManifests', {manifestIds: [this.$route.params.mId]}).then(response => {
	    			this.starred = !this.starred;
				})
	    	} else {
	    		axios.post('/addUserManifests', {manifestIds: [this.$route.params.mId]}).then(response => {
	    			this.starred = !this.starred;
				})
	    	}
		}
	}
}
</script>